var _path;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUpCorpIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 9,
    viewBox: "0 0 14 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.828122 7.07576L6.28828 0.703883C6.37629 0.601232 6.48547 0.518832 6.60831 0.46234C6.73116 0.405848 6.86478 0.376597 7 0.376597C7.13521 0.376597 7.26883 0.405848 7.39168 0.46234C7.51453 0.518832 7.6237 0.601232 7.71172 0.703883L13.1719 7.07576C13.693 7.68396 13.2609 8.62341 12.4602 8.62341H1.53828C0.737497 8.62341 0.305466 7.68396 0.828122 7.07576Z",
    fill: "#EEFDF4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpCorpIcon);
export default __webpack_public_path__ + "static/media/upCorpIcon.320886e5fc7eeddfc341f0c4905b85a0.svg";
export { ForwardRef as ReactComponent };